import { contrastRatio, HSLColor } from '@yola/yola-palette-generator';

const whiteColor = new HSLColor(0, 0, 1);

const isDark = (backgroundColor) => contrastRatio(backgroundColor, whiteColor) >= 3;

export default isDark;
